import React, { useState } from 'react';
import { useWorkspace } from '../../contexts/WorkspaceContext';
import { Button, Popover, ActionList, Text, InlineStack } from '@shopify/polaris';
import { ChevronDownIcon } from '@shopify/polaris-icons';

export const WorkspaceSelector = () => {
  const { currentWorkspace, workspaces, selectWorkspace } = useWorkspace();
  const [isOpen, setIsOpen] = useState(false);

  const handleWorkspaceSelect = async (workspace) => {
    try {
      // Call selectWorkspace and wait for the result
      const result = await selectWorkspace(workspace);
      
      if (result.success) {
        setIsOpen(false);
        
        // Reload the page to refresh data with new workspace context
        window.location.reload();
      }
      // Keep popover open if switch failed
    } catch (error) {
      // Keep popover open to show error
    }
  };

  const togglePopover = () => setIsOpen(!isOpen);

  if (!currentWorkspace || !workspaces.length) {
    return (
      <div className="workspace-selector-placeholder">
        <Text variant="bodySm" color="subdued">
          Loading...
        </Text>
      </div>
    );
  }

  const activator = (
    <Button
      onClick={togglePopover}
      variant="tertiary"
      className="workspace-selector-button"
    >
      <InlineStack gap="tight" align="center">
        <Text variant="bodySm" fontWeight="bold">
          {currentWorkspace.name}
        </Text>
        <div className="dropdown-icon">
          <ChevronDownIcon />
        </div>
      </InlineStack>
    </Button>
  );

  const workspaceActions = workspaces.map((workspace) => ({
    content: (
      <div className="workspace-action-item">
        <Text variant="bodySm" fontWeight="bold">
          {workspace.name}
        </Text>
      </div>
    ),
    onAction: () => handleWorkspaceSelect(workspace),
    disabled: workspace.id === currentWorkspace.id // Only disable currently selected workspace
  }));

  return (
    <Popover
      active={isOpen}
      activator={activator}
      onClose={() => setIsOpen(false)}
      preferredPosition="bottom right"
      preferredAlignment="right"
    >
      <ActionList
        title="Switch Workspace"
        items={workspaceActions}
        actionRole="menuitem"
      />
    </Popover>
  );
};
